// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"4e8eab70","78":"9ee67cf7","86":"313af00b","319":"ebfa13c6","453":"c7ab4a5e","500":"4230bfbf","590":"b2110547","662":"75c5e77e","672":"86f02e01","833":"e85ffb0d","969":"cce8c8b4"}[chunkId] + ".chunk.js";
};